<template>
  <div class="modal-popup">
    <div class="modal fade" id="payInvoiceModal" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="title mt-2 ml-2">Fatura ödeme ekle</h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class="la la-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="contact-form-action">
              <form method="post">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="input-box">
                      <label class="label-text">Ödeme Notu</label>
                      <input class="form-control" v-model="payInvoce.detail" id="refundReason" type="text" placeholder="">
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="input-box">
                      <base-select-input
                           v-model="payInvoce.channel"
                           :label="'Ödeme Kanalı'"
                           :rules="'required'"
                           :option-list="[{'id' : 'cash', 'name' : 'Nakit'}, {'id' : 'transfer', 'name' : 'transfer'}]">
                      </base-select-input>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer border-top-0 pt-0">
            <button type="button" class="btn font-weight-bold font-size-15 color-text-2 mr-2" data-dismiss="modal">Cancel</button>
            <button @click="accept" type="button" class="theme-btn theme-btn-small">Onaylıyorum</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseSelectInput from "../base/BaseSelectInput.vue";

export default {
  name: "PayInvoicePopup",
  components: {BaseSelectInput},
  data:function (){
    return{
      payInvoce: {
        detail: "",
        channel: "",
      }
    }
  },
  props : {
    "invoices": Array
  },
  computed:{
  },
  methods:{
    accept(){
      if(this.payInvoce.detail != null){

        this.invoices.forEach(invoice => {
          if(invoice.status === "new"){
            this.payInvoce.invoiceId = invoice.id;
          }
        })

        this.$store.dispatch("payInvoice", {invoiceId : this.payInvoce.invoiceId, detail : this.payInvoce.detail, channel : this.payInvoce.channel}).then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Başarılı',
            text: '',
          })
          window.location.reload();
        })
      }
    }
  },
  updated() {
    setTimeout(function () {
      $(".select-contain-select").selectpicker('refresh');
    }, 100);
    $(".select-contain-select").selectpicker({
      size: 5,
      noneSelectedText: 'Select One'
    });
  }
}
</script>

<style scoped>

</style>